"use client";

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useDownloader from "react-use-downloader";
import styles from "./Download.module.scss";
import { faDownload, faXmarkCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
interface Props {
  href: string;
  name: string;
  extension: string;
  showProgress?: boolean | undefined;
  className?: string | undefined;
  variant?: "default" | "text" | undefined;
  alwaysShowText?: boolean | undefined;
}
export default function Download(props) {
  const $ = _c(27);
  const {
    percentage,
    download,
    cancel,
    isInProgress
  } = useDownloader();
  const showProgress = props.showProgress ?? true;
  const variant = props.variant ?? "default";
  let t0;
  if ($[0] !== percentage) {
    t0 = Number.isFinite(percentage) ? Math.min(Math.max(percentage, 0), 100) : null;
    $[0] = percentage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const normalizedPercentage = t0;
  const [isCompleted, setIsCompleted] = useState(false);
  const completionTimeoutRef = useRef(null);
  let t1;
  if ($[2] !== download || $[3] !== props.extension || $[4] !== props.href || $[5] !== props.name) {
    t1 = async function startDownload() {
      const filename = props.extension ? `${props.name}.${props.extension}` : props.name;
      download(props.href, filename);
    };
    $[2] = download;
    $[3] = props.extension;
    $[4] = props.href;
    $[5] = props.name;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const startDownload = t1;
  let t2;
  let t3;
  if ($[7] !== normalizedPercentage || $[8] !== showProgress) {
    t2 = () => {
      if (normalizedPercentage === 100 && showProgress) {
        setIsCompleted(true);
        if (completionTimeoutRef.current) {
          clearTimeout(completionTimeoutRef.current);
        }
        completionTimeoutRef.current = setTimeout(() => {
          setIsCompleted(false);
          completionTimeoutRef.current = null;
        }, 1500);
      }
    };
    t3 = [normalizedPercentage, showProgress];
    $[7] = normalizedPercentage;
    $[8] = showProgress;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      if (completionTimeoutRef.current) {
        clearTimeout(completionTimeoutRef.current);
      }
    };
    t5 = [];
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== cancel || $[14] !== isCompleted || $[15] !== isInProgress || $[16] !== normalizedPercentage || $[17] !== props.alwaysShowText || $[18] !== showProgress || $[19] !== startDownload || $[20] !== variant) {
    t6 = () => {
      if (isCompleted) {
        return <div className="tw-inline-flex tw-h-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border-0 tw-bg-iron-900 tw-px-3 tw-text-white tw-transition tw-duration-300 tw-ease-out" aria-label="Download complete"><span className="tw-text-sm tw-font-medium tw-leading-[2.25rem]">Complete</span><FontAwesomeIcon icon={faCheckCircle} className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-cursor-pointer tw-text-white" onClick={() => setIsCompleted(false)} /></div>;
      }
      if (!isInProgress || !showProgress) {
        if (variant === "text") {
          return <button onClick={e => {
            e.stopPropagation();
            startDownload();
          }} className="tw-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-text-xs tw-font-medium tw-text-white/40 tw-transition-colors tw-duration-300 desktop-hover:hover:tw-text-white" aria-label="Download file" type="button"><ArrowDownTrayIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" /><span className={props.alwaysShowText ? "" : "tw-hidden sm:tw-inline"}>Download</span></button>;
        }
        return <button onClick={e_0 => {
          e_0.stopPropagation();
          startDownload();
        }} className="tw-inline-flex tw-size-9 tw-flex-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-iron-900 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-bg-iron-800" aria-label="Download file" type="button"><FontAwesomeIcon icon={faDownload} className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-white" /></button>;
      }
      return <div className="tw-inline-flex tw-h-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border-0 tw-bg-iron-900 tw-px-3 tw-text-white tw-transition tw-duration-300 tw-ease-out" aria-label="Downloading file"><span className="tw-text-sm tw-font-medium tw-leading-[2.25rem]">{normalizedPercentage === null ? "Downloading..." : `Downloading ${normalizedPercentage}%`}</span><FontAwesomeIcon icon={faXmarkCircle} className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-cursor-pointer tw-text-white" onClick={() => cancel()} /></div>;
    };
    $[13] = cancel;
    $[14] = isCompleted;
    $[15] = isInProgress;
    $[16] = normalizedPercentage;
    $[17] = props.alwaysShowText;
    $[18] = showProgress;
    $[19] = startDownload;
    $[20] = variant;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const renderContent = t6;
  const t7 = `${styles.download} ${props.className ?? ""}`;
  let t8;
  if ($[22] !== renderContent) {
    t8 = renderContent();
    $[22] = renderContent;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}